import { Button, ButtonProps } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ISidebarAction extends ButtonProps {
  icon?: IconProp;
  onClick?: () => void;
}

export const SidebarAction = (props: ISidebarAction) => {
  const { children, icon, onClick, ...restProps } = props;

  return (
    <Button
      onClick={onClick}
      variant={'ghost'}
      size={'sm'}
      justifyContent={'start'}
      textAlign={'left'}
      leftIcon={<FontAwesomeIcon icon={icon} className="utility-icon" fixedWidth />}
      {...restProps}
    >
      {children}
    </Button>
  );
};
